import React, { useContext, useCallback } from 'react';
import { GameContext } from '../context/GameContext';
import { SelectedNumbersList } from './SelectedNumberList';
import '../styles/NumberSelectionScreen.css';

const NumberSelectionScreen = () => {
  const {
    handleNumberPress,
    selectedNumbers,
    againstNumbers,
    remainingNumbers,
    limitLabel,
    selectedOption,
    limit,
  } = useContext(GameContext);

  const handleNumberPressCallback = useCallback(
    (number) => {
      const isSelected = selectedNumbers.includes(number);
      const isAgainstSelected = againstNumbers.includes(number);
      handleNumberPress(number, isSelected, isAgainstSelected);
    },
    [selectedNumbers, againstNumbers, handleNumberPress]
  );

  return (
    <div className="number-selection-container">      
      <h3 className="title">{`Pick Numbers (${remainingNumbers} more)`}</h3>

        <div className="number-grid2">
          {Array.from({ length: 90 }, (_, i) => i + 1).map((number) => {
            const isSelected = selectedNumbers.includes(number);
            const isAgainstSelected = againstNumbers.includes(number);

            return (
              <button
                key={number}
                onClick={() => handleNumberPressCallback(number)}
                className={`number-button2 ${isSelected ? 'selected' : ''} ${isAgainstSelected ? 'against' : ''}`}
                disabled={remainingNumbers === 0 && !isSelected}
              >
                {number}
              </button>
            );
          })}
        </div>
    </div>
  );
};

export default NumberSelectionScreen;
